module.exports = __webpack_public_path__ + "media/images/IBN2fD-6655ece27889fef9ce105808ed1352d6.jpg";